module.exports = __webpack_public_path__ + "static/img/4.6c74fdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/sp/4.png
// module id = iBz8
// module chunks = 0